import { RouteObject } from "react-router-dom";
import Login from "../pages/Login";
import Colaboracao from "../pages/Dashboard/Colaboracoes";
import NotFound from "../pages/NotFound";
import ProtectedRoute from "../components/ProtectedRoute";
import Logout from "../pages/Logout";
import Instituicoes from "../pages/Dashboard/Instituicoes";
import ContextoInstituicao from "../pages/Dashboard/ContextoInstituicao";
import ContextoColaboracao from "../pages/Dashboard/ContextoColaboracao";
import ContextoPlanoDeTrabalho from "../pages/Dashboard/ContextoPlanoDeTrabalho";
import PlanosDeTrabalho from "../pages/Dashboard/PlanosDeTrabalho";

export const routes: RouteObject[] = [
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/instituicoes",
    children: [
      {
          index: true,
          element: (
          <ProtectedRoute>
            <Instituicoes />
          </ProtectedRoute>
          )
      },
      {
      path: "/instituicoes/:id",
      element: (
        <ProtectedRoute>
          <ContextoInstituicao />
        </ProtectedRoute>
      )
    }]
  },
  {
    path: "/solicitacoes",
    children: [
      {
        index: true,
        element: (
          <ProtectedRoute>
            <PlanosDeTrabalho />
          </ProtectedRoute>
        ),
      },
      {
        path: "/solicitacoes/proposta/:idProposta",
        element: (
          <ProtectedRoute>
            <ContextoPlanoDeTrabalho />
          </ProtectedRoute>
        )
      }
    ]
  },
  {
    path: "/colaboracoes",
    children: [
      {
          index: true,
          element: (
            <ProtectedRoute>
              <Colaboracao />
            </ProtectedRoute>
          ),
      },
      {
        path: "/colaboracoes/:idEdital",
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute>
                <ContextoColaboracao />
              </ProtectedRoute>
            )
          },
          {
            path: "/colaboracoes/:idEdital/proposta/:idProposta",
            element: (
              <ProtectedRoute>
                <ContextoPlanoDeTrabalho />
              </ProtectedRoute>
            )
          }
        ]
        
      }]
  },
  {
    path: "/fomentos",
    children: [
      {
        index: true,
        element: (
          <ProtectedRoute>
            <PlanosDeTrabalho />
          </ProtectedRoute>
        ),
      },
      {
        path: "/fomentos/proposta/:idProposta",
        element: (
          <ProtectedRoute>
            <ContextoPlanoDeTrabalho />
          </ProtectedRoute>
        )
      }
    ]
  },
  {
    path: "/logout",
    element: (
      <ProtectedRoute>
        <Logout />
      </ProtectedRoute>
    ),
  },
  {
    path: "/*",
    element: <NotFound />,
  },
];
